import { useSyncExternalStore, useMemo } from "react";
import { PromoService } from "@domain/services/promo.service";

export function usePromo() {
  const store = PromoService.getStore();
  const state = useSyncExternalStore(store.subscribe, store.getState);

  const actions = useMemo(
    () => ({
      loadPromoList: PromoService.loadPromoList.bind(PromoService),
      loadActivePromo: PromoService.loadActivePromo.bind(PromoService),
      activatePromo: PromoService.activatePromo.bind(PromoService),
      deactivatePromo: PromoService.deactivatePromo.bind(PromoService),
    }),
    []
  );

  return {
    promoList: state.promoList,
    activePromo: state.activePromo,
    ...actions,
  };
}
